import { serializeTitle } from '@/utils/index.js'

export default {
  path: '/panier',
  name: 'Cart',
  component: () => import(/* webpackChunkName: "cart" */ '@/views/Cart.vue'),
  children: [{
    path: 'voir',
    name: 'ShowCart',
    component: () => import(/* webpackChunkName: "cart" */ '@/components/cart/Show.vue'),
    meta: {
      title: serializeTitle('Votre Panier'),
      requiresAuth: true,
      requiresCustomer: true,
    },
  }]
}